import styled, { css } from 'styled-components/macro';

import { large } from 'styles/breakpoints';
import { container } from 'styles/layout';
import { description } from 'styles/typography';

interface INotificationPreferenceContainerProps {
  isEmailChecked: boolean;
  isUnavailable: boolean;
}

interface IEmailContainerProps {
  customerNotificationPreferencesEnabled: boolean;
  isEmailChecked: boolean;
}

export const Container = styled.div`
  ${container}

  margin-top: 16px;
`;

export const NotificationPreferenceContainer = styled.div<INotificationPreferenceContainerProps>`
  ${({ theme }) => `
    transition: opacity ${theme.transitionDurationCarouselTrack} ease,
      margin-top ${theme.transitionDurationCarouselTrack} ease;
  `}

  ${({ isEmailChecked, isUnavailable }) => {
    if (!isUnavailable) {
      return `
        opacity: 1;
        margin-top: 0;
      `;
    } else if (isEmailChecked) {
      return `
        opacity: 0;
        margin-top: -143px;
      `;
    } else {
      return `
        opacity: 0;
        margin-top: -81px;
      `;
    }
  }}
`;

export const PillContainer = styled.div`
  position: relative;
  z-index: 2;

  ${({ theme }) => css`
    background: ${theme.bottomBackgroundColor};
  `}
`;

export const EmailContainer = styled.div<IEmailContainerProps>`
  margin: -43px auto -12px;
  opacity: 0;
  overflow: hidden;
  padding-right: 6px;
  transition-property: margin-top, opacity;
  transition-timing-function: ease;

  ${({ theme }) => css`
    transition-duration: ${theme.transitionDurationCarouselTrack};
  `}

  ${large`
    padding-right: 0;
    width: 360px;
  `}

  ${({ customerNotificationPreferencesEnabled, isEmailChecked }) => {
    if (isEmailChecked) {
      if (customerNotificationPreferencesEnabled) {
        return css`
          margin-top: 16px;
          opacity: 1;
        `;
      } else {
        return css`
          margin: 16px auto 0;
          opacity: 1;
        `;
      }
    }

    return '';
  }}
`;

export const CheckBoxContainer = styled.div`
  margin-top: 20px;
  text-align: center;
`;

export const EmailTitle = styled.h2`
  color: ${({ theme }) => theme.bottomForegroundPrimary};
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 16px;
  margin: 0 0 16px;
  text-transform: uppercase;
  width: 100%;
`;

export const DispatchFeeDescription = styled.p`
  ${description};

  ${({ theme }) => css`
    color: ${theme.bottomForegroundPrimary};
  `}
`;
